import { CheckFn, InputStatus } from './input-status';
import { StatusMessage } from './status-message';

export class ValidationErrorStatus {
  private static create = (error: string, message?: StatusMessage) =>
    InputStatus.create(
      (control) => control.touched && control.hasError(error),
      'danger',
      message
    );

  public static CUSTOM = (checkFn: CheckFn, message?: StatusMessage) =>
    InputStatus.create(checkFn, 'danger', message);

  public static REQUIRED_WITH_MESSAGE = (message?: StatusMessage) =>
    ValidationErrorStatus.create('required', message);

  public static REQUIRED = ValidationErrorStatus.REQUIRED_WITH_MESSAGE({
    text: 'VALIDATIONS.REQUIRED'
  });

  public static FILE_TYPE = (types: string) => {
    return InputStatus.create(
      (control) => control.hasError('FILE_NOT_VALID'),
      'danger',
      {
        text: 'VALIDATIONS.FILE_EXTENSION',
        params: {
          formats: types
        }
      }
    );
  };

  public static NOT_EMPTY = () => {
    return InputStatus.create(
      (control) => control.hasError('FILE_EMPTY'),
      'danger',
      {
        text: 'VALIDATIONS.EMPTY_FILE'
      }
    );
  };

  public static FILE_TOO_BIG = (maxSize: number) => {
    return InputStatus.create(
      (control) => control.hasError('FILE_TOO_BIG'),
      'danger',
      {
        text: 'VALIDATIONS.FILE_TOO_BIG',
        params: {
          maxSize: maxSize
        }
      }
    );
  };
}
